import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionPage.module.css";
import axios from 'axios';
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { subscribeApi } from '../Http/http';

const SubscriptionPage = () => {
    const [headerMsisdn, setHeaderMsisdn] = useState(null);
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(true);
    const [subscribeLoading, setSubscribeLoading] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (Cookies.get("msisdn")) {
            navigate("/home");
        }
    }, []);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const getToken = async () => {
        try {
            setLoading(true);
            const response = await axios.post(`https://mate.rashigames.com/get-token`);
            console.log(response, 'response...');
            fetchMsisdn(response?.data?.token);
            // after getting the token hit the getMsisdn api....
        } catch (error) {
            setLoading(false);

            console.log(error, 'error');
        }
    }

    const fetchMsisdn = async (token) => {
        try {

            const response = await axios.get(
                "https://sdp.tamaituk.com/api/v2/identity/getHeaderEnrichmentToken",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "X-App": "he-partner",
                        // "X-MessageID": "1234",
                        // "X-Source-System": "he-partner",
                    },
                }
            );

            console.log("Response Data:", response.data);

            const {
                Authorization,
                'Content-Type': contentType,
                'X-App': xApp,
                'X-Source-System': xSourceSystem,
                'x-messageid': xMessageId,
                url,
            } = response.data?.body;

            const secondResponse = await axios.get(url, {
                headers: {
                    Authorization,
                    'Content-Type': contentType,
                    'X-App': xApp,
                    'X-Source-System': xSourceSystem,
                    'x-messageid': xMessageId,
                },
            });

            console.log("MSISDN Response:", secondResponse.data);

            let numberFromHeader = secondResponse?.data?.ServiceResponse?.ResponseBody?.Response?.Msisdn;
            if (numberFromHeader) {
                setHeaderMsisdn(numberFromHeader);
            }

            const response2 = await axios.post(`https://mate.rashigames.com/print-logs/print`, {
                apiResponse: response.data,
                apiResponse2: JSON.stringify(secondResponse.data)
            });
            console.log(response2, 'respons2...');

            setLoading(false);

        } catch (error) {
            setLoading(false);

            console.error("API Error:", error);
            const response2 = await axios.post(`https://mate.rashigames.com/print-logs/print`, {
                apiError: error?.response?.data?.header ?? error
            });
            console.log(response2, 'response')
        }
    }

    const handleSubscription = async () => {
        try {
            if (headerMsisdn?.trim().length > 0 || msisdn?.trim().length > 0) {

                setSubscribeLoading(true);

                const responseIP = await axios.get("https://api.ipify.org?format=json");
                const response = await axios.post(subscribeApi, {
                    msisdn: headerMsisdn ?? msisdn,
                    ext_ref: extRef,
                    ip_address: responseIP?.data?.ip
                });

                console.log(response, 'response...');

                const response2 = await axios.post(`https://mate.rashigames.com/print-logs/print`, {
                    apiRequest: {
                        msisdn: headerMsisdn ?? msisdn,
                        ext_ref: extRef,
                        ip_address: responseIP?.data?.ip
                    },
                    apiResponse: JSON.stringify(JSON.stringify(response.data)),
                });
                console.log(response2, 'respons2...');

                setSubscribeLoading(false);

                let message = response?.data?.result?.message;
                let result = response?.data?.result;
                if (message == "User Already Exist" || result == 2) {
                    Cookies.set('msisdn', headerMsisdn, { expires: 1 });
                    navigate("/home");
                    return;
                }


                let redirect_url = response?.data?.result?.cg_url;
                if (redirect_url) {
                    window.location.href = redirect_url
                }
                else {
                    toast.error('Redirect url not found!');
                }

            }
            else {
                toast.error("Please Enter the Number!");
                return;
            }

        } catch (error) {
            console.log(error, 'error---');
            setSubscribeLoading(false);
            toast.error(error?.response?.data?.message || error?.response?.message || "Something Went Wrong!");
        }
    }


    useEffect(() => {
        getToken();
    }, []);
    return (
        <main className={classes.main}>
            {/* <div className={classes.header}>
                <img
                    src="wp-content/uploads/2024/04/cropped-Door2games-180x180.png"
                    className={classes.logo}
                    alt="gamezir"
                />
            </div> */}

            <div className={classes.container}>
                <h1 className={classes.portalDescription}>Mate Games</h1>

                <div className={classes.landingPageBanner}>
                    <img src="assets/banner.gif" alt="Banner" className={classes.banner} />
                </div>

                {loading ? <h1 style={{ textAlign: "center", width: "100%" }}>Loading...</h1> : (
                    <>
                        {!headerMsisdn ?
                            <p style={{ width: "100%", textAlign: "center" }}>Turn off Wifi and Switch to Safaricom Network to Subscribe the Service.</p> : (
                                <>
                                    <div className={classes.actions_box_container}>
                                        <div className={classes.actions_box}>
                                            <button type="button" className={classes.action_box}
                                                onClick={() => navigate(`/login?ext_id=${extRef}`)}
                                            >
                                                Login
                                            </button>
                                            <button type="button" className={`${classes.action_box} ${classes.active}`}
                                                onClick={() => navigate("/")}
                                            >
                                                Subscribe
                                            </button>
                                        </div>
                                    </div>
                                    <button className={classes.subscribeBtn} id="subscribe_btn" onClick={handleSubscription}
                                        disabled={subscribeLoading}
                                    >
                                        {subscribeLoading ? "Subscribing..." : (
                                            <>
                                                GET IT NOW <img src="assets/lock.png" alt="lock" className={classes.lockImg} />
                                            </>

                                        )}
                                    </button>

                                    <p className={classes.subscriptionChargeText}>Subscription KSH 15/Day</p>

                                    <div className={classes.termsSection}>
                                        <h1 className={classes.termsHeading}>Terms & Conditions</h1>
                                        <ul className={classes.termsList}>
                                            <li>The service cost is KSH 15/day.</li>
                                            <li>Your Subscription will be renewed at KSH 15/day, automatically until you unsubscribe.</li>
                                            <li>You can unsubscribe from the service anytime, by dialling USSD code *xxx# or deactivating from the portal.</li>
                                            <li>All data-enabled features & Smartphone users can enjoy full service.</li>
                                            <li>Customer can access the content at any time during the subscription validity period.</li>
                                        </ul>
                                    </div>
                                </>
                            )
                        }

                        <div style={{ width: "100%", display: "grid", placeContent: "center" }}>

                            <button className={classes.loginLink} onClick={() => navigate(`/login?ext_id=${extRef}`)}>
                                Already a Subscriber, Login
                            </button>
                        </div>

                    </>
                )
                }
            </div>


        </main >
    )
}

export default SubscriptionPage

